import { observer } from 'mobx-react'
import { useContext } from 'react'
import { Header } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import { SignRejectionPage } from '../SignRejectionPage'
import { VerificationFailedPage } from '../VerificationFailedPage'
import { Illustration } from '@/components/Illustration/Illustration'

export const SuccessOnventisPage = observer(() => {
  const store = useContext(StoreContext)
  const { successPage: trans } = store.TranslationsState.translations

  const location = window.location.href
  const url = new URL(location)
  const error = url.searchParams.get('error')
  const errorReason = url.searchParams.get('errorReason')

  if (errorReason && errorReason === 'userRejected') return <SignRejectionPage />
  if (error) return <VerificationFailedPage />

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      <div className="layout__centered-content">
        <Illustration type="identity-verification" />
      </div>

      <Header className="m-0-0-30">{trans.verificationPending}</Header>

      <div className="generic__paragraph-centered m-0-0-30">
        {trans.verificationPendingDescription}
      </div>
    </div>
  )
})
